import * as TYPE from '../types/sinister-cards';

export const setStoreFiles = (payload) => ({
  type: TYPE.SET_STORE_FILES,
  payload,
});
export const addPersonalInfo = (payload) => ({
  type: TYPE.ADD_PERSONAL_INFO,
  payload,
});
export const setSinisterList = (payload) => ({
  type: TYPE.SET_SINISTER_LIST,
  payload,
});
export const incrementStep = (payload) => ({
  type: TYPE.INCREMENT_STEP,
  payload,
});
export const reduceStep = (payload) => ({
  type: TYPE.REDUCE_STEP,
  payload,
});
export const setStep = (payload) => ({
  type: TYPE.SET_STEP,
  payload,
});
export const incrementSinister = (payload) => ({
  type: TYPE.INCREMENT_SINISTER,
  payload,
});
export const reduceSinister = (payload) => ({
  type: TYPE.REDUCE_SINISTER,
  payload,
});
export const setSinister = (payload) => ({
  type: TYPE.SET_SINISTER,
  payload,
});
export const updateSinisterList = (payload) => ({
  type: TYPE.UPDATE_SINISTER_LIST,
  payload,
});
export const storeNewFiles = (payload) => ({
  type: TYPE.STORE_NEW_FILES,
  payload,
});
export const setAccountInfo = (payload) => ({
  type: TYPE.SET_ACCOUNT_INFO,
  payload,
});
export const removeSinister = (payload) => ({
  type: TYPE.REMOVE_SINISTER,
  payload,
});
export const setUserInfo = (payload) => ({
  type: TYPE.SET_USER_INFO,
  payload,
});
export const setOtherInsurance = (payload) => ({
  type: TYPE.SET_OTHER_INSURANCE,
  payload,
});
export const deleteFiles = (payload) => ({
  type: TYPE.DELETE_FILES,
  payload,
});
export const setSinisterDate = (payload) => ({
  type: TYPE.SET_SINISTER_DATE,
  payload,
});
export const setSinisterNumberCase = (payload) => ({
  type: TYPE.SET_SINISTER_NUMBER_CASE,
  payload,
});
export const resetState = (payload) => ({
  type: TYPE.RESET_STATE,
  payload,
});

export const setOtherDescription = (payload) => ({
  type: TYPE.SET_OTHER_DESCRIPTION,
  payload,
});

export const setAdvisorInfo = (payload) => ({
  type: TYPE.SET_ADVISOR_INFO,
  payload,
});
